import { render, staticRenderFns } from "./otpInput.pug?vue&type=template&id=5860df01&lang=pug&"
import script from "./otpInput.js?vue&type=script&lang=js&"
export * from "./otpInput.js?vue&type=script&lang=js&"
import style0 from "./otpInput.scss?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/lauramunozruiz/multiasistencia/selfcarefront/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5860df01')) {
      api.createRecord('5860df01', component.options)
    } else {
      api.reload('5860df01', component.options)
    }
    module.hot.accept("./otpInput.pug?vue&type=template&id=5860df01&lang=pug&", function () {
      api.rerender('5860df01', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/input/modules/otp/index.vue"
export default component.exports